import { Component, OnInit, Inject, Injector } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';

import { TransporterService } from '../../../services/transporters/transporter.service';

import { Configuration } from '../../../../shared/configurations/shared.config';
import { ImageModalService } from '../../../services/image-modal.service';
import { IErrorHandler } from '../../../../shared/dataModels/contracts/IErrorHandler';
import { PointOfInterest } from '../../../dataModels/poi';
import { MasterComponentService } from '../../../../shared/services/master-component.service';
import { DiagnosedItem } from '../../../dataModels/diagnosed-item';

declare var google: any;

@Component({
    moduleId: module.id,
    selector: '[poi-details]',
    templateUrl: 'poi-details.component.html',
    providers: [TransporterService]
})
export class POIDetails extends DiagnosedItem {

    poi: PointOfInterest;
    languageList: any[];
    poiTypeList: any[];

    images: any[] = [];
    files: any[] = [];

    transporters: any[];

    private _errorHandler: IErrorHandler;

    constructor(private _http: Http, @Inject("IErrorHandler") handler: IErrorHandler,
        private _imageModalService: ImageModalService, private _transporterService: TransporterService,
        private _masterService: MasterComponentService, protected injector: Injector) {
        super(injector);

        this._errorHandler = handler;

        this.loadPoiTypes();

        this.LoadLanguages();

        this._masterService.detailsChanged.subscribe(obj => {

            this.poi = obj;
            this.images = [];
            this.files = [];


            ///            this.transporters = this._transporterService.filteredList.filter(x => x.POIDetails && x.POIDetails.NextPOI && x.POIDetails.NextPOI.POI && x.POIDetails.NextPOI.POI.Id == obj.Id);

            if (this.poi && this.poi.Attachments && this.poi.Attachments.length > 0) {

                var imgAttachments = this.poi.Attachments.filter(x => x.MediaType.includes('image'));

                for (var attach of imgAttachments) {

                    this.images.push({ thumb: attach.Url, img: attach.Url, description: attach.FileName });
                }

                var fileAttachments = this.poi.Attachments.filter(x => !x.MediaType.includes('image'));

                for (var file of fileAttachments) {

                    this.files.push({ name: file.FileName, url: file.Url });
                }
            }
        });
    }

    loadPoiTypes() {

        //Get POI Types
        this._http.get(Configuration.urls.webApiEndpoint + Configuration.urls.lookup_AllUrl + "POIType")
            .subscribe(response => {

                //If Ok
                if (response.ok) {

                    //Parse Response
                    var result = JSON.parse(response.text());

                    //If not Errored
                    if (result && !result.IsErrorState) {

                        this.poiTypeList = result.Value;
                    }
                    else {
                        this._errorHandler.Handle(Configuration.messages.defaultErrorMessage);
                    }
                }
                else {
                    this._errorHandler.Handle(Configuration.messages.defaultErrorMessage);
                }
            },
            error => {
                this._errorHandler.Handle(Configuration.messages.defaultErrorMessage);
            });

    }

    LoadLanguages() {

        //Get Language
        this._http.get(Configuration.urls.webApiEndpoint + Configuration.urls.lookup_AllUrl + "Language")
            .subscribe(response => {

                if (response && response.ok) {

                    var result = JSON.parse(response.text());

                    if (result && !result.IsErrorState) {
                        this.languageList = result.Value;
                    }
                }
            }, error => {
                this._errorHandler.Handle(Configuration.messages.defaultErrorMessage);
            });
    }

    OpenImageModel(imageSrc, images) {

        this._imageModalService.openModalRequest.emit({
            imageSrc: imageSrc, images: images
        })
    }

    onNextTransporter(nextTransporter) {

        this._masterService.nextBusClick.emit(nextTransporter.State.State.Location);
    }

    onCloseRigthBar() {
        this._masterService.closeRigthBar();
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/poi/poiDetails/poi-details.component.ts